import { useBranding, useIsAuthenticatingFlow } from '@packages/auth';

export interface BrandedLogoResult {
  logoUrl: string | null;
  showLogo: boolean;
  homeLink: string;
}

/**
 * Customer-specific logo hook.
 * Wraps shared useBranding with customer-specific auth-flow detection
 * and hash-based link targets for instance switching (/#cid=N).
 */
export function useBrandedLogo(): BrandedLogoResult {
  const { appLogoUrl, isEnabled, isResolved } = useBranding();
  const isAuthenticating = useIsAuthenticatingFlow();

  const currentHash = window.location.hash;
  const homeLink = `/${currentHash}`;

  const showLogo = !isAuthenticating && isEnabled && isResolved;

  return {
    logoUrl: appLogoUrl,
    showLogo,
    homeLink,
  };
}
